import {ProcessHook, ProcessHookProps, ProcessHookRunProps} from "./process-hooks";
import {JsonObject} from "typescript-json-serializer";
import {Contractor} from "../models/contractor";

/**
 * Hook to persist contractor information to process
 */
@JsonObject()
export class PersistContractorHook extends ProcessHook {

    class = "PersistContractorHook";
    constructor(props?: ProcessHookProps) { super(props); }

    run(runProps: ProcessHookRunProps): Promise<any> {
        return new Promise((resolve, reject) => {
            const {project, auftragsverwaltung} = runProps;

            if (!project.contractorId) {
                reject("Contractor not defined on project.");
                return;
            }

            const contractor =
				project.contractor ||
				auftragsverwaltung.ContractorStore.getItem(String(project.contractorId));

            if (!contractor) {
                // get from db
                reject("Contractor not found");
                return;
            }

            this.saveContractorAsText(contractor, runProps).then(() => {
                resolve("Auftragnehmer zur Datenabgabe in Projekttabelle gespeichert.");
            });
        });
    }

    private saveContractorAsText(contractor: Contractor, runProps: ProcessHookRunProps): Promise<void> {
        return new Promise((resolve) => {
            const {project, auftragsverwaltung, appStore} = runProps;

            const updated = {
                contractor: contractor.displayName
            };

            const user = appStore.esriCredential?.userId || "";
            const type = appStore.topic?.id === "projectsGk" ? "gefahrenkarte" : "risikoübersicht";

            auftragsverwaltung.ProjectStore?.save(project, type, updated, user).then(() => {
                resolve();
            });
        });
    }
}
